import { $api } from "@/utils/fetch.ts";
import type { SsoProviderId } from "@/shared/login-methods.ts";

/**
 * Public, pre-login deployment flags for the auth pages (which provider SSO
 * buttons to show). Unauthenticated — usable on the login/signup screens
 * before a token exists.
 */
export const publicAuthConfigQueryOptions = () =>
	$api.queryOptions("get", "/api/public/auth-config", undefined, {
		staleTime: 10 * 60 * 1000,
	});

/**
 * The auth code, the signed state and the flow secret all travel in headers
 * rather than the query string: they are credentials, and the query string ends
 * up in access logs and tracing attributes. The state plus the secret are what
 * prove the redirect came back to the client that started the flow.
 */
export const ssoOrganizationsQueryOptions = (
	authCode: string,
	state: string,
	flowSecret: string,
	provider: SsoProviderId,
) =>
	$api.queryOptions("get", "/api/auth/sso/list", {
		params: {
			query: {
				provider,
			},
			header: {
				"x-oauth-code": authCode,
				"x-oauth-state": state,
				"x-oauth-secret": flowSecret,
			},
		},
	});

export const useSsoLinkMutation = () =>
	$api.useMutation("post", "/api/auth/sso/link");

export const useSsoLoginMutation = () =>
	$api.useMutation("post", "/api/auth/sso/login");
